export default {
    "title": "趣头条Q3财报：营收11.3亿元 预计第四季度实现盈利",
    "time": "2020-12-17",
    "source": "Donews",
    "origin": "http://tech.hexun.com/2020-12-17/202640833.html",
    "content": `<div class="art_contextBox" style="visibility: visible; height: 500px; overflow: hidden; padding-top: 40px; position: relative;">

    <p style="text-indent:2em;">DoNews12月17日消息（记者 吴丽 ）趣头条（NASDAQ:QTT）今日发布了2020年第三季度财报。财报显示，趣头条第三季度营业收入11.3亿元，符合市场预期，亏损连续四个季度收窄，非<a href="http://news.hexun.com/usa/index.html" target="_blank">美国</a>通用会计准则下运营成本同比下降87.0%，运营亏损率同比去年的60.0%大幅收窄至9.7%。趣头条预计，公司将于今年第四季度实现经营性盈利。</p><p style="text-indent:2em;">趣头条董事长兼CEO谭思亮表示：“面临复杂多变的市场环境，我们的业务在第三季度仍取得了一些进步，亏损连续几个季度收窄。未来，我们将继续提升运营效率，在内容建设和商业化方面做出更多努力，以实现平台的长期价值。”</p>
    
                
    
    
                
    
    
    <div class="bottomLayer" style="height: 100px;width: 100%;background-image: -webkit-linear-gradient(top, rgba(255, 255, 255, 0), #ffffff);position: absolute;left: 0;bottom: 0;z-index: 0;"></div></div>`
}